import Offer from './offer'
import BidHistory from './bid-history'
import store from '@/state/store'
import { labelForValueInLookup, formatDateTime, formatDate, updateAllProperties, capitalize } from '@/utils/utils'

export default class Bid {
  constructor (values) {
    updateAllProperties(this, values)
  }

  get stateLabel () {
    if(this.bidState === 'TRADE_CANCELLED') return 'CANCELLED'
    let state = ((this.bidState === 'OPENED' || this.bidState === 'COUNTERED') && this.isExpired) ? 'EXPIRED' : this.bidState
    state = (this.bidType === 'FIRM' && state === 'BUYER_ACCEPTED') ? 'ACCEPTED' : state
    return state.replace(/_/g, ' ')
  }


  get  stateClass () {
    if (this.bidState.includes('ACCEPTED')) return 'strong icon-success'
    if (this.bidState.includes('PAID')) return 'strong icon-info'
    if (this.bidState.includes('CANCELLED')) return 'strong icon-danger'
    if (this.bidState.includes('REJECT')) return 'strong icon-danger'
    if (this.bidState.includes('EXPIRED')) return 'strong icon-danger'
    return ''
  }

  get dateCreatedFormatted () {return formatDateTime(this.dateCreated)}
  get dateSoldFormatted () {return formatDateTime(this.dateSold)}
  get dateSoldDateOnlyFormatted () {return formatDate(this.dateSold)}
  get bidLabel () {return Bid.formatQuantityPrice(this.quantity, this.price)}
  get bidTypeLabel () {return labelForValueInLookup(this.bidType, store.state.lookup.offerType)}
  get priceLabel () {return '$' + this.price }

  get bidBuyLabel () {
    const bidBuy = this.bidType === 'FIRM' ? 'buy' : 'bid'
    return this.isMine ? 'Your ' + bidBuy : capitalize(bidBuy)
  }

  // Offer pass through values
  get grainLabel () {return this.offer?.grainLabel}
  get gradeLabel () {return this.offer?.gradeLabel}
  get offerLabel () {return this.offer?.offerLabel}
  get seasonLabel () {return this.offer?.seasonLabel}
  get storageTypeLabel () {return this.offer?.storageTypeLabel} 
  get shortLocatedLabel () {
    if(this.transferType === 'DELIVERED') {
      return 'Delivered to ' + this.deliveryLocation?.city + ', ' + (this.deliveryLocation?.state || this.state || '')
    }
    return this.offer?.shortLocatedLabel
  }

  get isExpired () {
    return this.bidState === 'EXPIRED'
  }
  get isMine () {
    const org = store.getters['organisation/organisation'](this.orgId)
    return Boolean(org)
  }
  get deliveryLocationFormatted () {
    return this.deliveryLocation?.city + ', ' + (this.deliveryLocation?.state || this.state || '')
  }

  static formatQuantityPrice (quantity, price) {
    return quantity + 'mt @ $' + price + '/mt'
  }




  static setClass (obj) {
    if (obj instanceof Object !== true) return
    Object.setPrototypeOf(obj, Bid.prototype)
    Object.setPrototypeOf(obj.offer, Offer.prototype)
    BidHistory.setClasses(obj.stateHistory)
    return obj
  }
  static setClasses (objs) {
    objs.forEach(obj => Bid.setClass(obj))
    return objs
  }
  static copy (obj) {
    const copy = JSON.parse(JSON.stringify(obj))
    Bid.setClass(copy)
    return copy
  }
}
